import { RegepCompensationModel } from './enums/regepCompensationModel';
import { RegistrationOfEnergyProducerApplicationDocumentTypes } from './enums/regepDocumentTypes';
import { RegepInvoiceProcessType } from './enums/regepInvoiceProcessType';
import { RegepRegulatoryDataSectionsState } from './sections-state/regepRegulatoryDataSectionsState';
import { Document } from '../../jurisdiction/jurisdiction.domain';
import { EegEnergyProducer } from './regep-eeg-energy-producer';

export class RegistrationOfEnergyProducerRegulatoryData {
  application_id: number;
  is_waiver_compensation: boolean;
  compensation_model?: RegepCompensationModel;
  bank_account_holder?: string;
  bank_name?: string;
  bank_iban?: string;
  bank_bic?: string;
  due_invoice: boolean;
  credit_invoice: boolean;
  is_payment_with_vat: boolean;
  tax_office?: string;
  tax_id?: string;
  is_bafa_auth_granted: boolean;
  bafa_auth_notice_document: Document = new Document(RegistrationOfEnergyProducerApplicationDocumentTypes.BafaNoticeOfAuthorization);

  eeg_energy_producers: EegEnergyProducer[];
  document_ids_for_deletion: number[];
  regulatory_data_sections_state: RegepRegulatoryDataSectionsState;
}
